module.exports = __webpack_public_path__ + "img/carbon_customer.126ec917.svg";